import { render, staticRenderFns } from "./MailWhite.vue?vue&type=template&id=ca6c3c68&scoped=true&"
var script = {}
import style0 from "./MailWhite.vue?vue&type=style&index=0&id=ca6c3c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6c3c68",
  null
  
)

export default component.exports